/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {revokeAccountIntegration} from '../api'

export const useMutationRevokeAccountIntegration = createReactQueryMutationHook('revokeAccountIntegration', revokeAccountIntegration)
